import { MutationTree } from 'vuex'

import { UserState } from '@/types/store'
import { IUser } from '@/types/user'

export const mutations: MutationTree<UserState> = {
  logout(state) {
    state.user = null
  },
  getMe(state, payload: IUser) {
    state.user = payload
  },
}
